import React from "react";
import { SEO, MainLayout, ProfileLayout } from "../../../../components";

const ProfileMainPage = () => {
  return (
    <>
      <SEO title="profile" />
      <MainLayout>
        <ProfileLayout />
      </MainLayout>
    </>
  );
};

export default ProfileMainPage;
